import { ActionStandard } from "app/store/types";
import { UPDATE_MENU_OPEN } from "./menu-action-types";

export const updateMenuAction = (
  payload: boolean
): ActionStandard<boolean> => ({
  type: UPDATE_MENU_OPEN,
  payload
});
